const CENTS_THRESHOLD = 1000;
const CENTS_DIGITS = '1.2-2';
const WHOLE_DOLLAR_DIGITS = '1.0-0';

export function budgetVarianceDigits(value: number): string {
  const absoluteCents = Math.round(Math.abs(value) * 100);
  return absoluteCents < CENTS_THRESHOLD ? CENTS_DIGITS : WHOLE_DOLLAR_DIGITS;
}
